module.exports = __webpack_public_path__ + "img/VideoPromo.a352ef63.png";